<template>
	<div v-if="shouldRender && is_show">
		<div v-if="cur_city" class="good_list">
			<div class="good_list_head">
				<div>星级酒店至臻SPA为您打造奢华的疗愈体验</div>
				<div>尊贵与舒适交融·私密与美好共生·让身心在此焕活新生</div>
			</div>
			<!-- <naviBack 
		title="五星酒店SPA权益" 
		type="nav2" 
		background="#FFFFFF" 
		
		:type_time="type_time"
		
		:cur_city="cur_city" 
		:cur_city_list="cur_city_list" 
		 @selectDropdownCity="selectDropdownCity"/> -->

			<!-- <van-sticky> -->
				<div class="rcst_sc rcst_scgoodlist">
					<div class="rcst_sc_drop">
						<!-- <div @click="backPrev()" class="rcst_sc_drop_left">
		 				<img src="../resource/back.png" alt="" />
		 			</div> -->
						<van-dropdown-menu active-color="#FB8027">
							<van-dropdown-item v-model="cur_city" @change="selectDropdown" :options="cur_city_list" />
						</van-dropdown-menu>
					</div>
				</div>
			<!-- </van-sticky> -->

			<div class="gl">
				<div v-for="(item_1,index_1) in venus_list" :key="'bor1'+index_1" class="gl_item">
					<van-image class="gl_item_pic" fit="cover" :src="item_1.thumb" />
					<div class="gl_item_body">
						<div class="gl_item_title white_space">{{item_1.venue_name}}</div>
						<div class="gl_item_address white_space">{{item_1.district}}</div>
						<div class="gl_item_good">
							<div v-for="(item_2,index_2) in item_1.goods_info" :key="'bor2'+index_1+'-'+index_2"
								class="gl_item_good_item" @click="toDetail(item_2)">
								<div class="gl_item_good_item_left">
									<div class="gl_item_good_item_left_1 white_space">{{item_2.goods_name}}</div>
									<div class="gl_item_good_item_left_2">
										<div class="gl_item_good_item_left_2_1 font_weight">¥</div>
										<div class="gl_item_good_item_left_2_2 font_weight">{{item_2.price}}</div>
										<div class="gl_item_good_item_left_2_3">/次</div>
										<div class="gl_item_good_item_left_2_4">门市价¥{{item_2.market_price}}</div>
									</div>
								</div>
								<div class="gl_item_good_item_right">查看详情</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import naviBack from '../components/navi_back.vue';
	import {
		futureTimesGroup
	} from "../lib/utils.js"
	export default {
		components: {
			naviBack
		},
		data() {
			return {
				is_show: false,
				shouldRender: true,

				cur_city: '',
				cur_city_list: [],

				// date_list: futureTimesGroup(7),//日期列表
				// date_list_index:0,//日期列表索引

				type_time: 1, //切换列表类型 1:60分钟  2:90分钟

				venus_list: [],
			}
		},
		watch: {
			$route() {
				// 路由变化时更新渲染状态
				this.shouldRender = false
				this.$nextTick(() => {
					this.shouldRender = true
				})
			}
		},
		created() {
			// location.reload()
			var $this = this
			this.getUserInfo()
			this.cur_city = ''
			this.cur_city_list = []
			this.type_time = 1
			this.venus_list = []
			setTimeout(() => {
				$this.getCity()
			}, 50)
		},
		methods: {
			backPrev() {
				this.$router.go(-1)
			},
			getCity() {
				this.$loading('正在加载中...');
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getCityList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						var cur_city = res.data[0]
						var cur_city_list = []
						res.data.map((item) => {
							var param = {
								text: item,
								value: item
							}
							cur_city_list.push(param)
						})
						if (localStorage.getItem('cur_city')) {
							$this.cur_city = localStorage.getItem('cur_city')
						} else {
							$this.cur_city = '上海市' //res.data[0]
						}
						$this.cur_city_list = cur_city_list
						// $this.$loading.close();
						$this.getVenusList()
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg ? error.msg : error.message);
					})
			},
			selectDropdown(e) {
				this.$loading('正在加载中...');
				localStorage.setItem('cur_city', e)
				console.log(e);
				this.cur_city = e
				this.getVenusList()
			},

			getVenusList() {
				var $this = this
				var param = {
					city: this.cur_city,
					page: 1,
					page_size: 100
				}
				var qs = require('qs');
				let url = this.api.userApi.index_getGoodsList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						if (res.data && res.data.length > 0) {
							res.data.map((item_1) => {
								var goods_info = []
								for (var key in item_1.goods_list) {
									goods_info.push(item_1.goods_list[key])
								}
								item_1.goods_info = goods_info
							})
						}
						$this.venus_list = res.data
						$this.$loading.close();
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg ? error.msg : error.message);
					})
			},


			getUserInfo() {
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getUserInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						$this.is_show = true
						// $this.getLocation()
						if (res.data.url && res.data.url == 'order_detail') {
							$this.$router.push({
								name: res.data.url
							})
						}
					}).catch((error) => {
						console.warn(error)
						$this.$toast(error.msg ? error.msg : error.message ? error.message : "获取用户信息失败");
					})
			},
			// 前往订单详情
			toDetail(e) {
				window.scrollTo(0, 0);
				this.$router.push({
					name: 'goods_detail',
					params: {
						goods_id: e.goods_id
					}
				})
			}
		}
	}
</script>
<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.good_list{
		width: 100%;
		background: linear-gradient( 180deg, rgba(247,127,40,0.1) 0%, rgba(247,127,40,0) 714*@vm_base);
		.good_list_head{
			width: 100%;
			padding: 30*@vm_base 0 0 0;
			div{
				width: 100%;
				text-align: center;
				font-size: 26*@vm_base;
				color: #555555;
				line-height: calc(39 / 26);
			}
		}
	}

	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		// padding: 0 0 20*@vm_base 0;
		// background-color: #fff;

		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			padding: 0 30*@vm_base;

			// border: 1*@vm_base solid red;
			.rcst_sc_drop_left {
				width: 60*@vm_base;
				height: 100%;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;

				img {
					width: 36*@vm_base;
				}
			}
		}

	}

	.gl {
		width: 100%;
		padding: 5*@vm_base 30*@vm_base 30*@vm_base 30*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}

	.gl_item {
		width: 100%;
		background: #F9F9F9;
		border-radius: 16*@vm_base;
		margin-bottom: 20*@vm_base;

		&:last-child {
			margin-bottom: 0;
		}

		.gl_item_pic {
			width: 100%;
			height: 414*@vm_base;
			border-radius: 16*@vm_base;
			overflow: hidden;
		}

		.gl_item_body {
			width: 100%;
			padding: 0 20*@vm_base;
		}

		.gl_item_title {
			width: 100%;
			font-size: 36*@vm_base;
			color: #333333;
			padding: 26*@vm_base 0 16*@vm_base 0;
		}

		.gl_item_address {
			width: 100%;
			background-image: url(../resource/location.png);
			background-size: auto 100%;
			background-repeat: no-repeat;
			background-position: left center;
			padding: 2*@vm_base 0 1*@vm_base 36*@vm_base;
			font-size: 24*@vm_base;
			color: #999999;
		}

		.gl_item_good {
			width: 100%;
			padding: 20*@vm_base 0 10*@vm_base 0;

			.gl_item_good_item {
				width: 100%;
				height: 124*@vm_base;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-top: 1*@vm_base solid rgba(217, 217, 217, 0.80);

				.gl_item_good_item_left {
					width: calc(100% - 160*@vm_base);

					.gl_item_good_item_left_1 {
						width: 100%;
						font-size: 30*@vm_base;
						color: #333333;
					}

					.gl_item_good_item_left_2 {
						display: flex;
						justify-content: flex-start;
						align-items: flex-end;
						margin-top: 14*@vm_base;

						.gl_item_good_item_left_2_1 {
							font-size: 30*@vm_base;
							color: #F77F28;
							line-height: 1.1;
						}

						.gl_item_good_item_left_2_2 {
							font-size: 40*@vm_base;
							color: #F77F28;
						}

						.gl_item_good_item_left_2_3 {
							font-size: 22*@vm_base;
							color: #666666;
							margin-left: 8*@vm_base;
							line-height: 1.2;
						}

						.gl_item_good_item_left_2_4 {
							font-size: 22*@vm_base;
							color: #999999;
							text-decoration: line-through;
							margin-left: 30*@vm_base;
							line-height: 1.2;
						}
					}
				}

				.gl_item_good_item_right {
					width: 152*@vm_base;
					height: 50*@vm_base;
					background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
					border-radius: 25*@vm_base;
					font-size: 26*@vm_base;
					color: #FFFFFF;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/goods_list.vue